import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { Button } from '@pickleballinc/react-ui';
import { BettingAdvisory } from '@pickleballinc/ui/components/global/betting/BettingAdvisory';
import { BettingModal } from '@pickleballinc/ui/components/global/betting/BettingModal';
import clsx from 'clsx';
import { useState } from 'react';

import { publicEnv } from '@/lib/env';
import styles from '@/modules/homepage/ButtonsContainer/ButtonsContainer.module.css';
import { ButtonInterface } from '@/types/homepage.types';
import { BETTING_SITES_OPTIONS } from '@/utils/helpers/constants';

export interface ButtonsContainerProps {
  buttons: ButtonInterface[];
}

export const ButtonsContainer = ({ buttons }: ButtonsContainerProps) => {
  const wrapperClasses = clsx(styles.wrapper);
  const buttonClasses = clsx(styles.button);

  const [bettingModalOpen, setBettingModalOpen] = useState(false);
  const [bettingSite, setBettingSite] = useState<string | null>(null);
  const [pendingUrl, setPendingUrl] = useState<string | null>(null);

  const handleButtonClick = (button: ButtonInterface, event: React.MouseEvent) => {
    event.preventDefault();

    const textLower = button.text.toLowerCase();
    const urlLower = button.link.toLowerCase();
    const isBetting = button.isBetting || false;
    const bettingSite = button.bettingSite?.toLowerCase() || null;

    // Find if any option matches
    const matchedOption = BETTING_SITES_OPTIONS.find((option) => {
      const labelLower = option.label.toLowerCase();
      return (
        textLower.includes(labelLower) ||
        urlLower.includes(labelLower) ||
        (bettingSite && bettingSite === labelLower)
      );
    });

    // Check if text or URL contains "betting"
    const containsBetting = textLower.includes('betting') || urlLower.includes('betting');

    if (containsBetting || matchedOption || isBetting) {
      setPendingUrl(button.link);
      setBettingModalOpen(true);

      setBettingSite(matchedOption?.value || 'BETTING_SITE_OTHER');
    } else {
      window.open(button.link, '_blank');
    }
  };

  return (
    <div className={wrapperClasses}>
      {buttons.some((btn) => btn.isBetting) ? (
        <div className='px-4'>
          <BettingAdvisory pickleballHref={`${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}`} />
        </div>
      ) : null}
      {buttons.map((button) => {
        return (
          <a
            key={button.id}
            href={button.link}
            rel='noopener noreferrer'
            target='_blank'
            aria-label={`Link to ${button.link} (opens in a new tab)`}
            onClick={(e) => handleButtonClick(button, e)}
          >
            <Button size='sm' variant='secondary' className={buttonClasses}>
              {button.text}
            </Button>
          </a>
        );
      })}
      {bettingModalOpen && pendingUrl ? (
        <BettingModal
          open={bettingModalOpen}
          onClose={() => setBettingModalOpen(false)}
          onConfirm={() => {
            setBettingModalOpen(false);
            if (pendingUrl) window.open(pendingUrl, '_blank');
          }}
          bettingSite={bettingSite || 'the betting site'}
          pickleballImage={`${getCDNURL(`${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/PB-colored.svg`, 68, 68)}`}
        />
      ) : null}
    </div>
  );
};
